module.exports = __webpack_public_path__ + "img/grid-bullets.b6153b6e.svg";